import React,{useEffect,useState} from 'react';
import { fetchExternalData } from '../helper/helper';
import { useNavigate } from "react-router-dom";

const MainPage = () => {
    const [htmlContent, setHtmlContent] = useState(null);
    const navigate = useNavigate();

    const fetch = async(data) => {
        const response = await fetchExternalData(data);
        await setHtmlContent(response);
    }
    
    useEffect(() => {
      const url =  window.location.href.split('/')[3];
      fetch({url:url});
      // eslint-disable-next-line
    }, [window.location.pathname]);

    useEffect(() => {
      const handleClick = (e) => {
        const target = e.target.closest('a');
        if (target && target.href && !target.href.includes(window.location.origin)) {
          e.preventDefault();
          const domain = target.hostname;
          if(domain === 'my.timocom.com'){
             navigate(`/${domain}/app/tcgate/`);
          }
          if(domain === 'iam.timocom.com'){
            navigate(`/${domain}/`);
         }
          
        }
      };
  
      document.addEventListener('click', handleClick);
      return () => document.removeEventListener('click', handleClick);
      // eslint-disable-next-line
    }, [htmlContent]); // reattach when content changes

  return (
    <div>
       {htmlContent ? (
        <div>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
      ) : (
        <div className='loading-container'>
          <img src="/resources/img/logo.png" alt="TIMOCOM" />
        </div>
      )}
    </div>
  )
}

export default MainPage